/************ SEO ************/
/* TESTS: =>

https://search.google.com/test/rich-results/result?id=zz54C0K3A-CZ5eQcrXk5Ag&url=https%3A%2F%2Fpolygames-site.jcloud.ik-server.com%2F


 */
const _createSnippet = structuredData => {
    const jsonldScript = document.createElement('script');
    jsonldScript.setAttribute('type', 'application/ld+json');
    jsonldScript.textContent = JSON.stringify(structuredData);
    document.head.appendChild(jsonldScript);
};

//Organisation PG
const createOrganizationSnippet = () => {
    _createSnippet({
        '@context': 'http://schema.org/',
        '@type': 'Organization',
        name: 'Poly-Games',
        description:
            "Convention de jeu de rôle (jdr, jeu de rôle), de plateau, de cartes etc. fondée en 1994 à Sierre en Valais, qui a lieu chaque dernier weekend d'avril.",
        url: 'https://www.poly-games.ch',
        logo: 'https://polygames-site.jcloud.ik-server.com/img/2024_logo-full_v1_fond-transparent-small.webp',
    });
};

//Event
const createEventSnippet = () => {
    _createSnippet({
        '@context': 'https://schema.org',
        '@type': 'Event',
        name: 'Poly-Games 2024',
        startDate: '2024-04-26T18:00:00',
        endDate: '2024-04-28T15:00:00',
        eventAttendanceMode: 'https://schema.org/OfflineEventAttendanceMode',
        eventStatus: 'https://schema.org/EventScheduled',
        location: {
            '@type': 'Place',
            name: 'ASLEC Sierre',
            address: {
                '@type': 'PostalAddress',
                streetAddress: 'Route de la Monderèche 1',
                addressLocality: 'Sierre',
                postalCode: '3966',
                addressRegion: 'VS',
                addressCountry: 'CH',
            },
        },
        image: [
            'https://polygames-site.jcloud.ik-server.com/cdn/gallery/Affiches/2024.webp',
            'https://polygames-site.jcloud.ik-server.com/cdn/gallery/2023/JeuDePlateau_UnderwaterCities.jpeg',
        ],
        description:
            "Une convention de jeu historique, au soleil valaisan, avec du JDR, des jeux de plateau, de l'ambiance, des bonnes bières et de la bonne humeur.",
        organizer: {
            '@type': 'Organization',
            name: 'Génie de la Lampe',
            url: 'https://geniedelalampe.ch',
        },
    });
};

createOrganizationSnippet();
createEventSnippet();
/*******************************/
